module.exports = __webpack_public_path__ + "img/photo.21186c6f.png";